import React from 'react';
import ReactDOM from 'react-dom';

import LoginModal from '../modals/_LoginModal.jsx';
import RegisterConfirmModal from '../modals/_RegisterConfirmModal.jsx';

function returnModalNode() {
	const modalNode = document.createElement('div');
				modalNode.id = 'signupContainer';
				modalNode.classList.add('bl-3');
	
	return modalNode;
}

function showLoginModal(action) {
	document.body.appendChild(returnModalNode());
	ReactDOM.render(
		<LoginModal callback={action} />, 
		document.getElementById('signupContainer')
	);
}
function showSignupEmailModal(email, username) {
	document.body.appendChild(returnModalNode());

	ReactDOM.render(
		<RegisterConfirmModal keepContextAs="registerConfirmModal"/>, 
		document.getElementById('signupContainer')
	);
}

function logoutAndReload() {
	blapp.session.logout(() => blapp.util.reloadPage());
}

function closeSignupModal(){
	ReactDOM.unmountComponentAtNode(document.getElementById('signupContainer'));
	$( document.getElementById('signupContainer') ).remove();
	$("html, body").removeClass("disable-scroll");
}

window['bl'] = {login: {showLoginModal: (callback) => showLoginModal(callback), logoutAndReload: logoutAndReload, closeSignupModal: closeSignupModal, showSignupEmailModal: showSignupEmailModal}};